// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, no-plusplus */
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import fp from "lodash/fp"
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import _ from "lodash"
import { omit } from "ramda"
import { InputProps } from "@kiwicom/frontend-common/consts/form"

import { FIELD_VALIDATION_ERRORS, SUPPORTED_ATTACHMENTS } from "./BookingFileUploadConsts"

// VALIDATION
export const validateFile = (
  file: File,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  sizeLimit: number = 10000000,
): string | null | undefined => {
  let err = null
  const parts = file.name.split(".")
  const extension = parts[parts.length - 1]
  if (file.size > sizeLimit) {
    err = FIELD_VALIDATION_ERRORS.FILE_TOO_LARGE
  } else if (!SUPPORTED_ATTACHMENTS.includes(extension.toLowerCase())) {
    err = FIELD_VALIDATION_ERRORS.UNSUPPORTED_EXTENSION
  }
  return err
}

const isNotString = fp.negate(fp.isString)
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hasFile = (value: any) => isNotString(value) && value && value.length !== 0
const getLastField = (fields: (FileList | File[])[], fieldName: number) =>
  fields[fieldName][fields[fieldName].length - 1]

const filesToArray = (files: (File[] | FileList)[]): File[] => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!files) return []
  const flatFiles: File[] = []
  files.forEach((fileList) => {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (fileList) {
      for (let i = 0; i < fileList.length; i++) {
        // if there was removal from FileList it is an array
        // @ts-expect-error: Flow to TS migration.
        const file = fileList.item ? fileList.item(i) : fileList[i]
        // FIXME: a method has been detected that possibly mutates the object, consider a more
        // functional approach (Ramda might help)

        flatFiles.push(file)
      }
    }
  })

  return flatFiles
}

// Helper function for uploads
export const getLastFileFieldProps = fp.compose(fp.pick(InputProps), getLastField)
export const getLastFileFieldKey = fp.compose(fp.get("name"), getLastField)
export const hasLastFieldFile = fp.compose(hasFile, fp.get("value"), getLastField)

export const getAmountOfFiles = (fileBatches: (FileList | File[])[]) =>
  _.reduce(
    fileBatches,
    // @ts-expect-error: Flow to TS migration.
    (acc, fileList) => {
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      if (fileList && fileList.length) {
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return acc + fileList.length
      }
      return acc
    },
    0,
  )

// return object where key is file id and value is string describing error or null
export const validateFiles = (
  fileBatches: (FileList | File[])[],
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  sizeLimit: number = 10000000,
): string | null | undefined => {
  let totalFilesSize = 0
  // @ts-expect-error: Flow to TS migration.
  let err = null
  // @ts-expect-error: Flow to TS migration.
  _.forEach(fileBatches, (fileList) => {
    // @ts-expect-error: Flow to TS migration.
    if (!fileList || err) return
    for (let i = 0; i < fileList.length; i++) {
      // if there was removal from FileList it is an array
      const file = fileList.item ? fileList.item(i) : fileList[i]
      totalFilesSize += file.size
      err = validateFile(file, sizeLimit) // set to null or string
    }
  })
  if (totalFilesSize >= sizeLimit) {
    err = FIELD_VALIDATION_ERRORS.FILES_TOO_LARGE
  }
  return err
}

export function getFileURIs(files: (File[] | FileList)[]) {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!files) return []
  const flatFiles = filesToArray(files)

  const URIPromises = _.map(
    flatFiles,
    // @ts-expect-error: Flow to TS migration.
    (file) =>
      new Promise((resolve: (result: Promise<never>) => void) => {
        const reader = new FileReader()
        // @ts-expect-error: Flow to TS migration.
        reader.onload = (upload: ProgressEvent) => resolve(upload.target.result)
        reader.readAsDataURL(file)
      }),
  )

  return Promise.all(URIPromises)
}

export const getFileNames = (
  files: (File[] | FileList)[],
): {
  name: string
  size: number
}[] => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!files) return []

  const flatFiles = filesToArray(files)

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
  return flatFiles.reduce<Array<any>>((acc, file) => {
    // FIXME: a method has been detected that possibly mutates the object, consider a more
    // functional approach (Ramda might help)

    acc.push({
      name: file.name,
      size: file.size,
    })
    return acc
  }, [])
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const cleanFilesForPayloadTracking = (payload: any) => {
  if (typeof payload === "object" && payload.files) {
    const omittedPayload = omit(["files"], payload)

    if (payload.files.size) {
      return {
        ...omittedPayload,
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        files: `Submitted ${payload.files.size} file(s). Omitted for tracking.`,
      }
    }

    return omittedPayload
  }

  return payload
}
